---
fr:
  production_scheduling:
    dialog:
      close: Fermer
      day_ahead_hint: "« Charge nulle pour demain » et « Charge spécifique pour demain » n'affectent que l'offre day-ahead envoyée avant l'échéance de midi. Les heures d'aujourd'hui et les mises à jour continues/instantanées ne sont pas modifiées."
      end_date: Date de fin
      end_hour: Heure de fin
      instant_send_note: En confirmant, les intervalles situés dans les {days} prochains jours sont envoyés immédiatement au marché via l'InstantSender (instant operations plan). Les intervalles ultérieurs atteignent le marché via le flux automatique dès qu'ils entrent dans cette fenêtre. La production planifiée est mise à jour dans le graphique « Volume et prix » de l'onglet « Prévision ».
      instant_send_out_of_window: La plage sélectionnée commence au-delà de la fenêtre de soumission au marché de {days} jours ; rien n'est donc envoyé immédiatement au marché. Le remplacement met tout de même à jour la prévision et la production planifiée, et atteint le marché via le flux automatique dès qu'il entre dans la fenêtre.
      instant_send_partial_window: La plage sélectionnée s'étend au-delà de la fenêtre de soumission au marché de {days} jours. Les intervalles situés dans la fenêtre sont envoyés immédiatement au marché ; les suivants ne le sont pas et atteignent le marché via le flux automatique dès qu'ils entrent dans la fenêtre.
      override_type: Type de remplacement
      production_mw: Production (MW)
      send: Envoyer à Kaia Trade
      start_date: Date de début
      start_hour: Heure de début
      success: "{count} intervalles envoyés ({accepted} acceptés, {rejected} rejetés)"
      timezone_hint: Tous les horaires sont en {timezone}
      title: Envoyer remplacement pour {name}
    filter:
      all: Toutes
      disabled: Désactivé
      enabled: Activé
      label: 'Plan de production :'
    om_dashboard_link: Ouvrir le tableau de bord O&M
    override_types:
      specific_load_interval: Charge spécifique pour un intervalle
      specific_load_tomorrow: Charge spécifique pour demain
      zero_load_tomorrow: Charge nulle pour demain
    production_plan_toggle:
      error: 'Échec de la mise à jour du plan de production : {error}'
      label: Plan de production
    send_override: Envoyer remplacement
    shadow_toggle:
      error: 'Échec de la mise à jour du shadow testing : {error}'
      label: Shadow testing
    table:
      actions: Actions
      company: Entreprise
      continuous_forecast_enabled: Prévision continue
      day_ahead_forecast_enabled: Prévision day-ahead
      forecast_query_enabled: Requête de prévision
      kaia_uuid: Kaia UUID
      last_error: Dernière erreur connue
      last_override_sent: Dernier remplacement envoyé
      last_prod_plan_sent: Dernier plan de prod. envoyé à Trade
      name: Centrale
      production_simulation_plan_enabled: Plan de production
      shadow_testing: Shadow testing
      use_price_dependent_bid: Offre dépendante du prix
    title: Planification de prod.
